export default __webpack_public_path__ + "static/char-s-52-zh-Hans-b3751fa91065809160a454ea08aee1ff.png";